module.exports = __webpack_public_path__ + "static/1-d8d4742f19e0e56c0433bcf93371cb66.jpg";